import axios from '@/plugins/axios.js';

export default {
    namespaced: true,
    actions: {
        async registerLtiTool({ commit }, data) {
            return await axios.post('/api/integrations/lti/register', data);
        },

        async deployLtiTool({ commit }, { data, toolId }) {
            return await axios.post(`api/integrations/lti/register/${toolId}/deploy`, data);
        },

        async getRegistrationInfo() {
            return await axios.get('/api/integrations/lti/register/info');
        },

        async onCompleteConfiguration({ commit }, toolId) {
            return await axios.post(`/api/integrations/lti/register/${toolId}/set-configured`);
        },

        async onCompleteAndEnabled({ commit }, toolId) {
            await Promise.all([
                axios.post(`/api/integrations/lti/register/${toolId}/enable`),
                axios.post(`/api/integrations/lti/register/${toolId}/set-configured`),
            ]);
        },

        async disableIntegration({ commit }, toolId) {
            return await axios.post(`/api/integrations/lti/register/${toolId}/disable`);
        },

        async getRegisteredLtiToolInfo({ commit }, toolId) {
            return await axios.post(`/api/integrations/lti/get-registered-tool-info/${toolId}`);
        },

        async updateLtiToolRegisterUrls({ commit }, { toolId, data }) {
            return await axios.post(`/api/integrations/lti/update-ltitool-register-urls/${toolId}`, data);
        },

        async updateLtiToolAbilities({ commit }, { toolId, data }) {
            return await axios.post(`/api/integrations/lti/update-ltitool-abilities/${toolId}`, data);
        },
    },
};
